<template>
	<v-container grid-list-md>
		<ValidationObserver ref="obs" v-slot="{ invalid }">
			<v-form>
				<v-card>
					<v-card-title primary-title>
						<v-btn icon @click="
							$inertia.visit(
								$route('central.memberships.index')
							)
							"><v-icon>mdi-arrow-left</v-icon></v-btn>
						{{ $t("title.create_membership") }}
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<MembershipForm v-model="item" :tenants="tenants" :outlets="outlets" :categories="categories" :features="features"></MembershipForm>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="primary" @click.native="submit()" :loading="item.processing" :disabled="invalid">
							<v-icon left>mdi-content-save</v-icon>
							{{ $t("Save") }}
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</ValidationObserver>
	</v-container>
</template>
<script>
	import MembershipForm from "@Membership/forms/MembershipForm.vue";
	export default {
		props: ["tenants", "outlets", "categories", "features"],

		components: {
			MembershipForm,
		},

		data() {
			return {
				item: this.$inertia.form({
					name: {
						en: null,
						km: null,
						fr: null,
						zh: null,
					},
					code: null,
					bonus: null,
					price: null,
					signup_fee: null,
					invoice_period: null,
					invoice_interval: null,
					trial_period: null,
					trial_interval: null,
					grace_period: null,
					grace_interval: null,
					description: {
						en: null,
						km: null,
						fr: null,
						zh: null,
					},

					sample_card: null,
					active_subscribers_limit: null,
					active: true,
					is_public: true,
					is_flatiron: false,
					is_nbc: false,
					restaurant_validity: "all",
					tenant_ids: null,
					outlet_validity: "all",
					outlet_ids: null,
					category_validity: "all",
					category_ids: null,
					features: [],
					show_expiry_date_on_card: true,
					position: {
						name: {
							x: 0,
							y: 0,
						},
						code: {
							x: 0,
							y: 0,
						},
						expiry: {
							x: 0,
							y: 0,
						},
					}
				}),
			};
		},

		methods: {
			submit() {
				this.item.post(this.$route("central.memberships.store"), {
					forceFormData: true,
				});
			},
		},
	};
</script>
